import { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";

import LandingExperience from "../components/marketing/LandingExperience";
import WaitlistModal from "../components/marketing/WaitlistModal";

/**
 * OrbitCell public landing page for orbitcell.io.
 *
 * Every request-access CTA opens <WaitlistModal />; the `source` string
 * captures which CTA converted the developer so attribution is preserved on
 * the backend in waitlist.source.
 */
export default function LandingPage() {
  const location = useLocation();
  const [modalSource, setModalSource] = useState<string | null>(null);
  const isOpen = modalSource !== null;
  const requestedWaitlistSource = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const requestedSource = params.get("waitlist")?.trim();
    if (requestedSource) return requestedSource.slice(0, 80);
    if (location.hash === "#waitlist") return "public-hash";
    return null;
  }, [location.hash, location.search]);

  const openWaitlist = useCallback((source: string) => setModalSource(source), []);
  const closeWaitlist = useCallback(() => setModalSource(null), []);

  useEffect(() => {
    if (requestedWaitlistSource) {
      setModalSource(requestedWaitlistSource);
    }
  }, [requestedWaitlistSource]);

  return (
    <>
      <LandingExperience onRequestAccess={openWaitlist} />
      <WaitlistModal
        open={isOpen}
        onClose={closeWaitlist}
        source={modalSource ?? undefined}
      />
    </>
  );
}
